require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.date.now");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (t) {
  var e = {};

  function n(i) {
    if (e[i]) return e[i].exports;
    var o = e[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return t[i].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, i) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: i
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var i = Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(i, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return i;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 5);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  t.exports = n(2)();
}, function (t, e, n) {
  "use strict";

  var i = n(3);

  function o() {}

  function r() {}

  r.resetWarningCache = o, t.exports = function () {
    function t(t, e, n, o, r, a) {
      if (a !== i) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: r,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (t, e, n) {}, function (t, e, n) {
  "use strict";

  n.r(e);

  var i = "bottom-left",
      o = "bottom-right",
      r = "bottom-center",
      a = "top-left",
      c = "top-right",
      s = "top-center",
      u = "center",
      l = "top",
      f = "bottom",
      p = "success",
      m = "danger",
      d = "info",
      h = "default",
      y = "warning",
      v = "timeout",
      b = "click",
      g = "touch",
      E = "manual",
      S = function S(t) {
    return null == t;
  };

  function w(t) {
    return t === i || t === o || t === r;
  }

  function O(t) {
    return t === a || t === c || t === s;
  }

  function N(t) {
    var e = t.type,
        n = t.content,
        i = t.userDefinedTypes,
        o = ["notification-item"];
    if (n) return o;
    if (S(i)) return function (t) {
      switch (t) {
        case h:
          return ["notification-item", "notification-default"];

        case p:
          return ["notification-item", "notification-success"];

        case m:
          return ["notification-item", "notification-danger"];

        case y:
          return ["notification-item", "notification-warning"];

        case d:
          return ["notification-item", "notification-info"];

        default:
          return ["notification-item"];
      }
    }(e);
    var r = i.find(function (t) {
      return t.name === e;
    });
    return o.concat(r.htmlClasses);
  }

  function T(t, e) {
    var n = t.duration,
        i = t.timingFunction,
        o = t.delay;
    return "".concat(n, "ms ").concat(e, " ").concat(i, " ").concat(o, "ms");
  }

  function k(t, e) {
    var n = e.duration,
        i = e.timingFunction,
        o = e.delay,
        r = t || {};
    return S(r.duration) && (r.duration = n), S(r.timingFunction) && (r.timingFunction = i), S(r.delay) && (r.delay = o), r;
  }

  function j(t, e) {
    var n = t,
        i = n.id,
        o = n.type,
        r = n.insert,
        a = n.content,
        c = n.container,
        s = n.animationIn,
        u = n.animationOut,
        l = n.slidingEnter,
        f = n.slidingExit,
        v = n.touchRevert,
        b = n.touchSlidingExit,
        g = n.dismiss,
        E = n.width,
        w = n.onRemoval;
    n.id = i || C.counter, n.type = a ? null : o.toLowerCase(), e && !a && (n.userDefinedTypes = function (t, e) {
      var n = t.content,
          i = t.type;
      if (!n && i !== p && i !== m && i !== d && i !== h && i !== y && e) return e;
    }(n, e)), S(E) || (n.width = E), n.container = c.toLowerCase(), n.insert = (r || "top").toLowerCase(), n.dismiss = function (t) {
      var e = t,
          n = {
        duration: 0,
        click: !0,
        touch: !0,
        onScreen: !1,
        waitForAnimation: !1,
        showIcon: !1
      };
      return e ? (Object.keys(n).forEach(function (t) {
        S(e[t]) && (e[t] = n[t]);
      }), e) : n;
    }(g), n.animationIn = s || [], n.animationOut = u || [], n.onRemoval = w || function () {};

    var O = function O(t, e, n) {
      return {
        duration: t,
        timingFunction: e,
        delay: n
      };
    };

    n.slidingEnter = k(l, O(600, "linear", 0)), n.slidingExit = k(f, O(600, "linear", 0)), n.touchRevert = k(v, O(600, "linear", 0));
    var N = b || {},
        T = N.swipe,
        j = N.fade;
    return n.touchSlidingExit = N, n.touchSlidingExit.swipe = k(T || {}, O(600, "linear", 0)), n.touchSlidingExit.fade = k(j || {}, O(300, "linear", 0)), n;
  }

  var R = n(0),
      P = n.n(R);

  var C = new function () {
    var t = this;
    return this.types = null, this.counter = 0, this.add = function () {}, this.addNotification = function (e) {
      var n = t.types;
      return t.counter += 1, t.add(j(e, n));
    }, this.removeNotification = function () {}, this.register = function (e) {
      var n = e.addNotification,
          i = e.removeNotification,
          o = e.types;
      t.add = n, t.removeNotification = i, t.types = o;
    }, this;
  }(),
      M = n(1),
      _ = n.n(M),
      x = function x(t, e) {
    var n,
        i,
        o = e;
    this.pause = function () {
      clearTimeout(n), o -= Date.now() - i;
    }, this.resume = function () {
      i = Date.now(), clearTimeout(n), n = setTimeout(t, o);
    }, this.clear = function () {
      clearTimeout(n);
    }, this.resume();
  };

  function L(t) {
    return (L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function A(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
      var n = [],
          i = !0,
          o = !1,
          r = void 0;

      try {
        for (var a, c = t[Symbol.iterator](); !(i = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); i = !0) {
          ;
        }
      } catch (t) {
        o = !0, r = t;
      } finally {
        try {
          i || null == c["return"] || c["return"]();
        } finally {
          if (o) throw r;
        }
      }

      return n;
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function D(t, e) {
    var n = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(t);
      e && (i = i.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, i);
    }

    return n;
  }

  function I(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = null != arguments[e] ? arguments[e] : {};
      e % 2 ? D(Object(n), !0).forEach(function (e) {
        F(t, e, n[e]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (e) {
        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
      });
    }

    return t;
  }

  function F(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function W(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function z(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  function X(t) {
    return (X = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function q(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function U(t, e) {
    return (U = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  var H = function (t) {
    function e(t) {
      var n, i, o;
      !function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), i = this, (n = !(o = X(e).call(this, t)) || "object" !== L(o) && "function" != typeof o ? q(i) : o).rootElementRef = P.a.createRef(), n.onClick = n.onClick.bind(q(n)), n.onTouchStart = n.onTouchStart.bind(q(n)), n.onTouchMove = n.onTouchMove.bind(q(n)), n.onTouchEnd = n.onTouchEnd.bind(q(n)), n.onMouseEnter = n.onMouseEnter.bind(q(n)), n.onMouseLeave = n.onMouseLeave.bind(q(n));
      var r = t.notification.width;
      return n.state = {
        parentStyle: {
          height: 0,
          overflow: "hidden",
          width: r ? "".concat(r, "px") : "100%"
        },
        htmlClassList: N(t.notification),
        animationPlayState: "running",
        touchEnabled: !0
      }, n;
    }

    var n, i, o;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && U(t, e);
    }(e, t), n = e, (i = [{
      key: "componentWillUnmount",
      value: function value() {
        this.timer && this.timer.clear();
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var t = this,
            e = this.props,
            n = e.notification,
            i = e.count,
            o = n.dismiss,
            r = o.duration,
            a = o.onScreen,
            c = this.rootElementRef.current.scrollHeight,
            s = function (t, e) {
          return !(e <= 1) && e > 1 && (t.insert === l && O(t.container) || t.insert === f && w(t.container) || t.container === u);
        }(n, i),
            p = function p() {
          r && !a && (t.timer = new x(function () {
            return t.removeNotification(v);
          }, r));
        };

        this.setState(function (t) {
          return {
            parentStyle: {
              width: t.parentStyle.width,
              height: "".concat(c, "px"),
              transition: s ? T(n.slidingEnter, "height") : "10ms height"
            },
            onTransitionEnd: p
          };
        }, function () {
          requestAnimationFrame(function () {
            t.setState(function (t) {
              return {
                htmlClassList: [].concat(W(n.animationIn), W(t.htmlClassList))
              };
            });
          });
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value(t) {
        var e = t.removed;
        this.props.removed && !e && this.removeNotification(E);
      }
    }, {
      key: "removeNotification",
      value: function value(t) {
        var e = this,
            n = this.props,
            i = n.notification,
            o = n.toggleRemoval,
            r = i.id,
            a = i.onRemoval,
            c = i.dismiss.waitForAnimation,
            s = [].concat(W(i.animationOut), W(N(i))),
            u = function u() {
          return o(r, function () {
            return a(r, t);
          });
        },
            l = {
          height: 0,
          transition: T(i.slidingExit, "height")
        };

        return c ? this.setState(function (t) {
          var n = t.parentStyle.width;
          return {
            htmlClassList: s,
            onAnimationEnd: function onAnimationEnd() {
              e.setState({
                parentStyle: I({
                  width: n
                }, l),
                onTransitionEnd: u
              });
            }
          };
        }) : this.setState(function (t) {
          return {
            parentStyle: I({
              width: t.parentStyle.width
            }, l),
            onTransitionEnd: u,
            htmlClassList: s
          };
        });
      }
    }, {
      key: "onClick",
      value: function value() {
        var t = this.props.notification.dismiss;
        (t.click || t.showIcon) && this.removeNotification(b);
      }
    }, {
      key: "onTouchStart",
      value: function value(t) {
        var e = A(t.touches, 1)[0].pageX;
        this.setState(function (t) {
          var n = t.parentStyle;
          return {
            startX: e,
            currentX: e,
            parentStyle: I({}, n, {
              position: "relative"
            })
          };
        });
      }
    }, {
      key: "onTouchMove",
      value: function value(t) {
        var e = this,
            n = t.touches,
            i = this.state.startX,
            o = this.props,
            r = o.toggleRemoval,
            a = o.notification,
            c = a.id,
            s = a.onRemoval,
            u = a.slidingExit,
            l = a.touchSlidingExit,
            f = l.swipe,
            p = l.fade,
            m = A(n, 1)[0].pageX,
            d = m - i,
            h = this.rootElementRef.current.offsetWidth,
            y = window.innerWidth + h,
            v = "".concat(m - i >= 0 ? y : -y, "px");

        if (function (t, e) {
          return Math.abs(t) >= .4 * e;
        }(d, h)) {
          var b = T(f, "left"),
              E = T(p, "opacity"),
              S = function S() {
            r(c, function () {
              return s(c, g);
            });
          };

          return this.setState(function (t) {
            return {
              touchEnabled: !1,
              parentStyle: I({}, t.parentStyle, {
                left: v,
                opacity: 0,
                transition: "".concat(b, ", ").concat(E)
              }),
              onTransitionEnd: function onTransitionEnd() {
                e.setState(function (t) {
                  return {
                    parentStyle: I({}, t.parentStyle, {
                      height: 0,
                      transition: T(u, "height")
                    }),
                    onTransitionEnd: S
                  };
                });
              }
            };
          });
        }

        return this.setState(function (t) {
          var e = t.parentStyle;
          return {
            currentX: m,
            parentStyle: I({}, e, {
              left: "".concat(0 + d, "px")
            })
          };
        });
      }
    }, {
      key: "onTouchEnd",
      value: function value() {
        var t = this.props.notification.touchRevert;
        this.setState(function (e) {
          return {
            parentStyle: I({}, e.parentStyle, {
              left: 0,
              transition: T(t, "left")
            })
          };
        });
      }
    }, {
      key: "onMouseEnter",
      value: function value() {
        this.timer ? this.timer.pause() : this.setState({
          animationPlayState: "paused"
        });
      }
    }, {
      key: "onMouseLeave",
      value: function value() {
        this.timer ? this.timer.resume() : this.setState({
          animationPlayState: "running"
        });
      }
    }, {
      key: "renderTimer",
      value: function value() {
        var t = this,
            e = this.props.notification.dismiss,
            n = e.duration,
            i = e.onScreen,
            o = this.state.animationPlayState;

        if (n && i) {
          var r = {
            animationName: "timer",
            animationDuration: "".concat(n, "ms"),
            animationTimingFunction: "linear",
            animationFillMode: "forwards",
            animationDelay: 0,
            animationPlayState: o
          };
          return P.a.createElement("div", {
            className: "timer"
          }, P.a.createElement("div", {
            className: "timer-filler",
            onAnimationEnd: function onAnimationEnd() {
              return t.removeNotification(v);
            },
            style: r
          }));
        }
      }
    }, {
      key: "renderCustomContent",
      value: function value() {
        var t = this.state.htmlClassList,
            e = this.props.notification,
            n = e.id,
            i = e.content,
            o = e.dismiss,
            r = o.duration,
            a = o.pauseOnHover,
            c = r > 0 && a;
        return P.a.createElement("div", {
          className: "".concat([].concat(W(t), ["n-child"]).join(" ")),
          onMouseEnter: c ? this.onMouseEnter : null,
          onMouseLeave: c ? this.onMouseLeave : null
        }, P.a.isValidElement(i) ? i : P.a.createElement(i, {
          id: n
        }));
      }
    }, {
      key: "renderNotification",
      value: function value() {
        var t = this.props.notification,
            e = t.title,
            n = t.message,
            i = t.dismiss,
            o = i.showIcon,
            r = i.duration,
            a = i.pauseOnHover,
            c = this.state.htmlClassList,
            s = r > 0 && a;
        return P.a.createElement("div", {
          className: "".concat([].concat(W(c), ["n-child"]).join(" ")),
          onMouseEnter: s ? this.onMouseEnter : null,
          onMouseLeave: s ? this.onMouseLeave : null
        }, P.a.createElement("div", {
          className: "notification-content"
        }, o && P.a.createElement("div", {
          className: "notification-close",
          onClick: this.onClick
        }), e && P.a.createElement("div", {
          className: "notification-title"
        }, e), P.a.createElement("div", {
          className: "notification-message"
        }, n), this.renderTimer()));
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props.notification,
            e = t.content,
            n = t.dismiss.click,
            i = this.state,
            o = i.parentStyle,
            r = i.onAnimationEnd,
            a = i.onTransitionEnd,
            c = i.touchEnabled;
        return P.a.createElement("div", {
          ref: this.rootElementRef,
          onClick: n ? this.onClick : null,
          className: "notification-parent",
          style: o,
          onAnimationEnd: r,
          onTransitionEnd: a,
          onTouchStart: c ? this.onTouchStart : null,
          onTouchMove: c ? this.onTouchMove : null,
          onTouchEnd: c ? this.onTouchEnd : null
        }, e ? this.renderCustomContent() : this.renderNotification());
      }
    }]) && z(n.prototype, i), o && z(n, o), e;
  }(P.a.Component);

  H.propTypes = {
    toggleRemoval: _.a.func.isRequired,
    count: _.a.number.isRequired,
    removed: _.a.bool
  };
  var V = H;
  n(4);

  function B(t) {
    return (B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function Y(t) {
    return function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, n = new Array(t.length); e < t.length; e++) {
          n[e] = t[e];
        }

        return n;
      }
    }(t) || function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    }(t) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }

  function G(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }

  function J(t) {
    return (J = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
  }

  function K(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function Q(t, e) {
    return (Q = Object.setPrototypeOf || function (t, e) {
      return t.__proto__ = e, t;
    })(t, e);
  }

  var Z = function (t) {
    function e(t) {
      var n, i, o;
      return function (t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, e), i = this, (n = !(o = J(e).call(this, t)) || "object" !== B(o) && "function" != typeof o ? K(i) : o).state = {
        isMobile: t.isMobile,
        breakpoint: t.breakpoint,
        notifications: []
      }, n.add = n.add.bind(K(n)), n.remove = n.remove.bind(K(n)), n.toggleRemoval = n.toggleRemoval.bind(K(n)), n.handleResize = n.handleResize.bind(K(n)), n;
    }

    var n, l, f;
    return function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && Q(t, e);
    }(e, t), n = e, (l = [{
      key: "componentDidMount",
      value: function value() {
        var t = this.props.types;
        C.register({
          addNotification: this.add,
          removeNotification: this.remove,
          types: t
        }), this.setState({
          width: window.innerWidth
        }), window.addEventListener("resize", this.handleResize);
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.handleResize);
      }
    }, {
      key: "handleResize",
      value: function value() {
        this.setState({
          width: window.innerWidth
        });
      }
    }, {
      key: "add",
      value: function value(t) {
        return this.setState(function (e) {
          var n = e.notifications;
          return {
            notifications: "top" === t.insert ? [t].concat(Y(n)) : [].concat(Y(n), [t])
          };
        }), t.id;
      }
    }, {
      key: "remove",
      value: function value(t) {
        this.setState(function (e) {
          return {
            notifications: e.notifications.map(function (e) {
              return e.id === t && (e.removed = !0), e;
            })
          };
        });
      }
    }, {
      key: "toggleRemoval",
      value: function value(t, e) {
        this.setState(function (e) {
          return {
            notifications: e.notifications.filter(function (e) {
              return e.id !== t;
            })
          };
        }, e);
      }
    }, {
      key: "renderNotifications",
      value: function value(t) {
        var e = this;
        return t.map(function (n) {
          return P.a.createElement(V, {
            id: n.id,
            key: n.id,
            notification: n,
            toggleRemoval: e.toggleRemoval,
            count: t.length,
            removed: n.removed
          });
        });
      }
    }, {
      key: "renderMobileNotifications",
      value: function value(t) {
        var e = t.className,
            n = t.id,
            i = function (t) {
          var e = [],
              n = [];
          return t.forEach(function (t) {
            var i = t.container,
                o = u;
            O(i) || i === o ? e.push(t) : w(i) && n.push(t);
          }), {
            top: e,
            bottom: n
          };
        }(this.state.notifications),
            o = this.renderNotifications(i.top),
            r = this.renderNotifications(i.bottom);

        return P.a.createElement("div", {
          id: n,
          key: "mobile",
          className: "react-notification-root ".concat(e || "")
        }, P.a.createElement("div", {
          className: "notification-container-mobile-top"
        }, o), P.a.createElement("div", {
          className: "notification-container-mobile-bottom"
        }, r));
      }
    }, {
      key: "renderScreenNotifications",
      value: function value(t) {
        var e = t.className,
            n = t.id,
            l = function (t) {
          var e = [],
              n = [],
              l = [],
              f = [],
              p = [],
              m = [],
              d = [];
          return t.forEach(function (t) {
            var h = t.container;
            h === a ? e.push(t) : h === c ? n.push(t) : h === s ? l.push(t) : h === i ? f.push(t) : h === o ? p.push(t) : h === r ? m.push(t) : h === u && d.push(t);
          }), {
            topLeft: e,
            topRight: n,
            topCenter: l,
            bottomLeft: f,
            bottomRight: p,
            bottomCenter: m,
            center: d
          };
        }(this.state.notifications),
            f = this.renderNotifications(l.topLeft),
            p = this.renderNotifications(l.topRight),
            m = this.renderNotifications(l.topCenter),
            d = this.renderNotifications(l.bottomLeft),
            h = this.renderNotifications(l.bottomRight),
            y = this.renderNotifications(l.bottomCenter),
            v = this.renderNotifications(l.center);

        return P.a.createElement("div", {
          id: n,
          key: "screen",
          className: "react-notification-root ".concat(e || "")
        }, P.a.createElement("div", {
          className: "notification-container-top-left"
        }, f), P.a.createElement("div", {
          className: "notification-container-top-right"
        }, p), P.a.createElement("div", {
          className: "notification-container-bottom-left"
        }, d), P.a.createElement("div", {
          className: "notification-container-bottom-right"
        }, h), P.a.createElement("div", {
          className: "notification-container-top-center"
        }, m), P.a.createElement("div", {
          className: "notification-container-center"
        }, P.a.createElement("div", {
          className: "center-inner"
        }, v)), P.a.createElement("div", {
          className: "notification-container-bottom-center"
        }, y));
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props.isMobile,
            e = this.state,
            n = e.width,
            i = e.breakpoint;
        return t && n <= i ? this.renderMobileNotifications(this.props) : this.renderScreenNotifications(this.props);
      }
    }]) && G(n.prototype, l), f && G(n, f), e;
  }(P.a.Component);

  Z.propTypes = {
    isMobile: _.a.bool,
    breakpoint: _.a.number,
    types: _.a.array
  }, Z.defaultProps = {
    isMobile: !0,
    breakpoint: 768
  };
  var $ = Z;
  n.d(e, "store", function () {
    return C;
  });
  e["default"] = $;
}]);